import { useCallback } from 'react';

import { useCriteriaRequirementsState } from '../criteria/useCriteriaRequirementsState';
import { EditableRequirement } from '../../types';
import { useCurrentRequirementIndex } from './useCurrentRequirementIndex';

export const useRequirementState = () => {
  const { requirements, setRequirements } = useCriteriaRequirementsState();
  const index = useCurrentRequirementIndex();
  const requirement = requirements[index];
  const setRequirement = useCallback(
    (setterFn: (currentRequirement: EditableRequirement) => EditableRequirement) =>
      setRequirements((currentRequirements) =>
        currentRequirements.map((currentRequirement, i) =>
          i === index ? setterFn(currentRequirement) : currentRequirement,
        ),
      ),
    [setRequirements, index],
  );
  return { requirement, setRequirement };
};
